module.exports = __webpack_public_path__ + "static/media/illustration.4ed620a7.png";